import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class Error extends Component {
  render() {
    const { children } = this.props;
    return (
      <Grid container justify="center" alignItems="center" alignContent="center" style={{ height: '100vh' }}>
        <Typography variant="h4">
          {children}
        </Typography>
      </Grid>
    );
  }
}

export default Error;



// WEBPACK FOOTER //
// ./src/components/Error.js